import React, { useContext, useEffect, useState } from "react";
import { Card, Col, Modal, ModalBody, ModalHeader, Table } from "reactstrap";
import { Btn, H3 } from "../../AbstractElements";
import { UserActivityContext } from "./ContextProvider";

export default function ReportDetail() {
  //context
  const { modalTogle, modal, item } = useContext(UserActivityContext);

  const [newValues, setNewValues] = useState({});
  const [oldValues, setOldValues] = useState({});
  const [tableRows, setTableRows] = useState([]);

  useEffect(() => {
    if (item?.old_values) {
      let values = [];
      try {
        values = JSON.parse(item?.old_values);
      } catch (e) {
        console.log("Error parsing old values: ", e);
      }
      setOldValues(values);
    }

    if (item?.new_values) {
      let values = [];
      try {
        values = JSON.parse(item?.new_values);
      } catch (e) {
        console.log("Error parsing old values: ", e);
      }
      setNewValues(values);
    }
  }, [item]);

  useEffect(() => {
    let rows = [];
    switch (item["event"]) {
      case "updated":
        rows = Object.keys(oldValues);
        setTableRows(rows);
        break;
      case "deleted":
        rows = Object.keys(oldValues);
        setTableRows(rows);
        break;
      case "created":
        rows = Object.keys(newValues);
        setTableRows(rows);
        break;

      default:
        break;
    }
  }, [newValues, oldValues]);

  return (
    <Modal isOpen={modal} toggle={modalTogle} className="rounded-1">
      <ModalHeader toggle={modalTogle}>
        <div>
          <H3
            attrH3={{
              className: "modal-title",
              id: "exampleModalLabel1",
            }}
          >
            Detalle de la actividad del usuario
          </H3>
        </div>
      </ModalHeader>
      <ModalBody>
        <Col sm="12">
          <Card>
            <div className="card-block row">
              <Col sm="12">
                <div className="table-responsive">
                  <Table>
                    <thead className="table-dark">
                      <tr>
                        <th scope="col">ATRIBUTO</th>
                        <th scope="col">ANTERIOR</th>
                        <th scope="col">ACTUAL</th>
                      </tr>
                    </thead>
                    <tbody>
                      {tableRows.map((item) => (
                        <tr key={item}>
                          <th scope="row">{item}</th>
                          <td>
                            {item != "perms" ? oldValues[item]?.toString() : ""}
                            {item == "perms" && oldValues[item] != undefined
                              ? oldValues[item]
                                  .map((perm) => perm.name)
                                  .join(", ")
                              : ""}
                          </td>
                          <td>
                            {item != "perms" ? newValues[item]?.toString() : ""}
                            {item == "perms" && newValues[item] != undefined
                              ? newValues[item]
                                  .map((perm) => perm.name)
                                  .join(", ")
                              : ""}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </Col>
            </div>
          </Card>
        </Col>
        <Btn
          attrBtn={{
            color: "primary",
            className: "ms-1",
            onClick: modalTogle,
          }}
        >
          OK
        </Btn>
      </ModalBody>
    </Modal>
  );
}
